import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import bankAccountService from '../../service/bankAccount.service';

const BankAccountReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection, autoCompleteOptions }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    bankAccountService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'bankAccountNumber',
      headerName: 'Bankszámlaszám',
      type: 'string',
    },
    {
      field: 'bankName',
      headerName: 'Bank neve',
      type: 'string',
    },
    {
      field: 'iban',
      headerName: 'IBAN szám',
      type: 'string',
    },
    {
      field: 'currencyCode',
      headerName: 'Pénznem',
      type: 'singleSelect',
      sortable: false,
      renderCell: (data) => {
        return data.row.currencyCode;
      },
      valueOptions: autoCompleteOptions.currency,
    },
    {
      field: 'costCenterCode',
      headerName: 'Költséghely',
      type: 'singleSelect',
      sortable: false,
      renderCell: (data) => {
        return data.row.costCenter?.name;
      },
      valueOptions: autoCompleteOptions.costCenter,
    },
    {
      field: 'currencyDefault',
      headerName: 'Pénznem alapértelmezett',
      type: 'boolean',
    },
    {
      field: 'default',
      headerName: 'Alapértelmezett',
      type: 'boolean',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.BankAccountReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default BankAccountReports;
